// extracted by mini-css-extract-plugin
module.exports = {"imageContainer":"hL","image":"hM","contentContainer":"hN","mainText":"hO","subText":"hP","counter":"hQ","button":"hR"};